export class TriggerSOSAction {
    constructor() {
        this.name = 'TriggerSOS';
        this.isDeviceAction = true;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVHJpZ2dlclNPU0FjdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvbW9kZWxzL2FjdGlvbnMvVHJpZ2dlclNPU0FjdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLQSxNQUFNLE9BQU8sZ0JBQWdCO0lBQTdCO1FBQ2tCLFNBQUksR0FBRyxZQUFZLENBQUM7UUFDcEIsbUJBQWMsR0FBRyxJQUFJLENBQUM7SUFDeEMsQ0FBQztDQUFBIn0=